import React from 'react';
import {withRouter} from "react-router-dom";

class Profile extends React.Component {
    render() {
        let {
            firstname,
            surname,
            email,
            address,
            phoneNumber,
            nickname,
            gender,
            age,
            dateOfBirth
        } = this.props.sessionData.loggedUser;

        address = address instanceof Object ? address.street + ' ' + address.number + <br/> + address.zip + ' ' + address.city + <br/> + address.state : '';

        return (
            <div className="right-col" role="main">
                <div className="x-panel">
                    <div className="x-title">
                        <h2>Profil</h2>
                        <div className="clearfix"/>
                    </div>
                    <div className="x-content">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <h2>Kontaktní informace:</h2>
                            <table className="table table-striped">
                                <tbody>
                                <tr>
                                    <th>Jméno a příjmení:</th>
                                    <td>{firstname} {surname}</td>
                                </tr>
                                <tr>
                                    <th>E-mail:</th>
                                    <td>{email}</td>
                                </tr>
                                <tr>
                                    <th>Telefon:</th>
                                    <td>{phoneNumber}</td>
                                </tr>
                                <tr>
                                    <th>Adresa:</th>
                                    <td>{address}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <h2>Osobní informace:</h2>
                            <table className="table table-striped">
                                <tbody>
                                <tr>
                                    <th>Přezdívka:</th>
                                    <td>{nickname}</td>
                                </tr>
                                <tr>
                                    <th>Pohlaví:</th>
                                    <td>{gender ? (gender === 'M' ? 'Muž' : 'Žena') : ''}</td>
                                </tr>
                                <tr>
                                    <th>Datum narození:</th>
                                    <td>{dateOfBirth}</td>
                                </tr>
                                <tr>
                                    <th>Věk:</th>
                                    <td>{age}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Profile);



/** WEBPACK FOOTER **
 ** ./src/containers/Profile/index.js
 **/